let cached: boolean | undefined

/**
 * Classic OS scrollbars occupy layout width (Windows, Linux, macOS "Always show
 * scrollbars"). Overlay scrollbars do not (macOS default, iOS, Android).
 */
export function hasObtrusiveScrollbars(): boolean {
  if (cached !== undefined) {
    return cached
  }
  if (typeof document === "undefined" || !document.body) {
    return false
  }

  const parent = document.createElement("div")
  parent.setAttribute("style", "width:30px;height:30px;overflow:auto")

  const child = document.createElement("div")
  child.setAttribute("style", "width:100%;height:40px")
  parent.appendChild(child)
  document.body.appendChild(parent)

  const childWidth = child.clientWidth
  document.body.removeChild(parent)

  // jsdom reports 0 for clientWidth (no layout). Overlay scrollbars keep the
  // child's width at 30; classic ones shrink it.
  cached = childWidth > 0 && childWidth < 30
  return cached
}
